module.exports = __webpack_public_path__ + "static/media/TUSHAR.5c5b175b.jpg";